import { createControlComponent } from './core';
// import { Control } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { Control as LeafletControl, ControlOptions } from '@anlan/gs-map';
const Control = L.Control;
export const ZoomControl = createControlComponent(function createZoomControl(props: ControlOptions): LeafletControl {
    return new Control.Zoom(props);
});
